import React, { useContext } from 'react'
import { GrLocation } from 'react-icons/gr'
import { HiOutlineBriefcase } from 'react-icons/hi2'
import SuperAdminContext from '../../hooks/SuperAdminContext';
import { useNavigate } from 'react-router-dom';
import { TbNotes } from "react-icons/tb";
import { AiFillTrademarkCircle, AiOutlinePercentage } from "react-icons/ai";
import { TfiMedallAlt } from 'react-icons/tfi';
import { BiMedal } from 'react-icons/bi';
import { RiMedal2Line, RiVerifiedBadgeLine } from 'react-icons/ri';
import { TbCalendarTime } from "react-icons/tb";
import { FaInfinity } from "react-icons/fa";

const SuperAdminCard = ({ profile_percentage, pricing_category, profile_image, professional_id, id, first_name, last_name, job_title, city, handleSelectedData, notes, recom_jobs }) => {
  const {
    setSelectedCard,
    smallDevice
  } = useContext(SuperAdminContext);

  const pageRender = useNavigate();


  const handleCard = (id) => {
    handleSelectedData(id)
    setSelectedCard(true)

    if (smallDevice) {
      pageRender("/super_admin/professional/candidates_details")
    }
  }

  return (
    <div className="cursorPointer" onClick={() => handleCard(id)}>
      <div className="card border-0 rounded-4">
        <div className="card-body">
          <div className="row align-items-center pt-3">
            {/* card image  */}
            <div className="col-4 col-xl-3">
              <img src={`${process.env.REACT_APP_SECOND_CAREERS_CDN}${profile_image}`} alt="" width={83} height={83} className="rounded-circle" />
            </div>

            {/* card content  */}
            <div className="col-8 col-xl-8 px-1 pt-lg-3 pt-xl-0 position-relative">
              <div className="col-12">
             
                <div className="mb-0 employer-card-candidate-name d-flex align-items-center">
                  {first_name} {last_name}
                  {
                    notes !== "" && notes !== null ?
                      <div className="d-inline-block ps-2">
                        <TbNotes className='fs-5 brand-color' title="Expert notes" />
                      </div>
                      :
                      null
                  }


                  {
                    recom_jobs.length > 0 ?
                      <div className="d-inline-block ps-1">
                        <AiFillTrademarkCircle className='fs-5 text-success' title="Recommended" />
                      </div>
                      :
                      null
                  }
                </div>                

                <div className="pt-1">
                  <p className="mb-0 employer-card-candidate-role">
                    <span className="pe-2"><FaInfinity className='brand-color fs-5' /></span>
                    {professional_id}
                  </p>
                  <p className="mb-0 employer-card-candidate-role">
                    <span className="pe-2"><HiOutlineBriefcase /></span>
                    {job_title}
                  </p>
                  <p className="mb-0 employer-card-candidate-location">
                    <span className="pe-2"><GrLocation /></span>
                    {city}
                  </p>
                </div>

                {
                  profile_percentage ? <div className='super-admin-profile-percentage mt-1'>
                    {profile_percentage}% profile completed
                  </div>
                    :
                    null
                }
              </div>

            </div>
          </div>
        </div>
      </div>

      <div className='flex-shrink-0 appliedOrSaved'>
        <div
          className={`py-1 px-3 appliedOrSaved-borderRadius
                  ${pricing_category === "unpaid" ? 'basic-plan' : null ||
              pricing_category === "trialing" ? 'basic-plan' : null ||
                pricing_category === "Basic" ? 'basic-plan' : null ||
                  pricing_category === "Premium" ? 'premium-plan' : null ||
                    pricing_category === "Platinum" ? 'platinum-plan' : null ||
                      pricing_category === "cancelled" ? 'platinum-plan' : null ||
                        pricing_category === "incomplete" ? 'platinum-plan' : null ||
                          pricing_category === "complete" ? 'platinum-plan' : null ||
                            pricing_category === "canceled" ? 'platinum-plan' : null
            }`
          }>

          <div className='m-0 px-2'>{pricing_category === "unpaid" ? <span><TfiMedallAlt className='fs-5' /> Basic</span> : null ||
            pricing_category === "trialing" ? <span><RiVerifiedBadgeLine className='fs-5' /> Free trial</span> : null ||
              pricing_category === "Basic" ? <span><TfiMedallAlt className='fs-5' /> Basic</span> : null ||
                pricing_category === "complete" ? <span><TfiMedallAlt className='fs-5' /> Basic</span> : null ||
                  pricing_category === "Premium" ? <span><BiMedal className='fs-5' /> Premium</span> : null ||
                    pricing_category === "Platinum" ? <span><RiMedal2Line className='fs-5' /> Platinum</span> : null ||
                      pricing_category === "cancelled" ? <span><TbCalendarTime className='fs-5' /> Plan Canceled</span> : null ||
                        pricing_category === "canceled" ? <span><TbCalendarTime className='fs-5' /> Plan Canceled</span> : null ||
                          pricing_category === "incomplete" ? <span><TbCalendarTime className='fs-5' /> Expired</span> : null
          }</div>
        </div>
      </div>
    </div>
  )
}

export default SuperAdminCard